import React from 'react';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const TradeInJapan = () => (
  <div className="legal">
    <Head>
      <title>特商法に基く表記 | オンライン英会話のリンガルボックス</title>
    </Head>
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
      <div className="mt-12 mb-26 text-wrap">
        <h1 className="mb-8">特定商取引法に基く表記</h1>
        <h4>販売事業者名</h4>
        <p className="mb-6">LingualBox, Inc 日本支店</p>
        <h4>運営統括責任者</h4>
        <p className="mb-6">手島淳裕</p>
        <h4>本店所在地</h4>
        <p className="mb-6">アメリカ合衆国　デラウェア州</p>
        <h4>日本支店所在地</h4>
        <p className="mb-6">
          〒110-0016　東京都台東区台東4-6-5 グリーンプラザ504号
        </p>
        <h4>電話番号</h4>
        <p className="mb-6">050-3693-5183</p>
        <h4>メールアドレス</h4>
        <p className="mb-6">support@lingualbox.com</p>
        <h4>支払方法</h4>
        <p className="mb-6">クレジットカード決済</p>
        <h4>消費税について</h4>
        <p className="mb-6">全ての表示価格には、消費税が含まれています。</p>
        <h4>商品以外の必要料金</h4>
        <p className="mb-6">なし</p>
        <h4>商品について</h4>
        <p className="mb-6">
          特定商取引法上の商品に該当するものはございません。レッスンは全てオンラインで行います。
          また教材はオリジナル教材を無償配布しております。
        </p>
        <h4>サービスの開始時期</h4>
        <p className="mb-6">PayPalを通じたクレジットカード決済完了後</p>
        <h4>料金の返還・退会</h4>
        <p className="mb-6">
          月額制サービスのため、月途中の退会でも既にお支払い頂いた料金の返還は致しかねます。
        </p>
        <h4>販売価格</h4>
        <p className="mb-6">月額定額制</p>
      </div>
    </div>
  </div>
);

export const getStaticProps = async ({ locale = 'ja' }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common', 'terms'])),
  },
});

export default TradeInJapan;
